import React from "react";
import reactDOM from "react-dom";
import "normalize.css/normalize.css";
import App from "./App";

reactDOM.render(<App />, window.document.getElementById("root"));
